(function() {
  "use strict";

  angular.module("app").directive("cccAssetsList", cccAssetsList);

  function cccAssetsList() {
    return {
      restrict: "EA",
      scope: false,
      controller: "AssetsListController"
    };
  }
})();
